export const SearchError = () => {
  return (
    <div className="space-y-4 rounded-lg bg-secondary-grey-05 p-8 text-black">
      <h3 className="font-bold">Something went wrong</h3>
      <h5 className="font-bold">Sorry, an error occured when processing your search. Please try:</h5>
      <ul className="ml-6 list-disc space-y-2 text-sm text-[#4b4b4b]">
        <li>Reloading the webpage.</li>
        <li>If problems persist, try again later.</li>
      </ul>
    </div>
  );
};
